<template>
  <div class="componentRoot" style="display: flex; justify-content: center;">
    <v-container fluid id="loginPage" style="">
      <v-row>
        <v-col :cols="loginCols" :class="paddingClass" style="display: flex; align-items: center; z-index: 5;">
          <v-form ref="loginForm" style="width: 100%">
            <v-container fluid style="background-color: rgb(var(--v-theme-light));" class="pa-16">
              <v-row>
                <v-spacer />
                <v-col cols="6" @click="gotoLanding()">
                  <v-img src="logo_small.png" style="width: 100%; height: 100%" />
                </v-col>
                <v-spacer />
              </v-row>
              <v-row>
                <v-spacer />
                <v-col>
                  <v-img :src="logo" style="width: 100%; height: 100%" />
                </v-col>
                <v-spacer />
              </v-row>

              <v-row>
                <v-spacer />
                <v-col :cols="12" class="pt-0">
                  <v-text-field id="email" name="username" type="email" autocomplete="username" density="compact"
                    :rules="emailRules" label="E-Mail" v-model="email" required variant="outlined"
                    class="backgroundInputColor" flat />
                </v-col>
                <v-spacer />
              </v-row>
              <v-row>
                <v-spacer />
                <v-col :cols="12" class="pt-0">


                  <v-text-field id="password" name="password" autocomplete="current-password" density="compact"
                    :rules="passwordRules" :type="showEyeOpen ? 'password' : 'text'" :label="$t('basics.password')"
                    v-model="password" required variant="outlined" class="backgroundInputColor"
                    :append-inner-icon="showEyeOpen ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="switchPWDisplay"
                    flat />
                </v-col>
                <v-spacer />
              </v-row>
              <v-row>
                <v-col :cols="12" style="display: flex" class="pt-0">
                  <v-btn @click="login()" class="primaryButton keepMobile" flat large block :loading="loading">{{
                    $t("basics.login") }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="12" style="display: flex" class="pt-5">
                  <v-btn @click="goToRegister()" class="primaryButton keepMobile" flat large block>{{
                    $t("basics.register")
                    }}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="12" style="text-align: center">
                  <a :href="resetURL" large block>{{ $t("messages.forgotPassword") }} </a>
                </v-col>
              </v-row>

            </v-container>
          </v-form>
        </v-col>
        <v-col :cols="mainCols" :style="{
          position: isMobile ? 'absolute' : 'block',
        }" style="left: 0; top: 0" class="pa-0">
          <img src="/images/main/background.jpeg" style="height: 100vh; object-fit: cover; width: 100%" />
        </v-col>
      </v-row>
      <v-snackbar v-model="maintenanceSnackbar" color="primary" :timeout="-1" location="top center">
        <v-icon size="xx-large">mdi-information-outline</v-icon>
        <br />
        <h3>{{ $t("basics.maintenance") }}!</h3>
        <br />
        <p v-if="maintenance.display_start_date == maintenance.display_end_date">
          {{
            $t("basics.maintenanceIntervalSimple", {
              startDate: maintenance.display_start_date,
              endDate: maintenance.display_end_date,
              startTime: maintenance.display_start_time,
              endTime: maintenance.display_end_time,
            })
          }}
        </p>
        <p v-else>
          {{
            $t("basics.maintenanceIntervalMultiple", {
              startDate: maintenance.display_start_date,
              endDate: maintenance.display_end_date,
              startTime: maintenance.display_start_time,
              endTime: maintenance.display_end_time,
            })
          }}
        </p>

        <template v-slot:actions>
          <v-btn class="py-3 mb-3" text @click="maintenanceSnackbar = false"> Ok! </v-btn>
        </template>
      </v-snackbar>
    </v-container>

  </div>
</template>

<script>
import ThemePickerVue from "../components/main/ThemePicker.vue";
export default {
  name: "login",

  data() {
    return {
      showEyeOpen: true,

      password: undefined,
      email: undefined,

      loading: false,

      isValid: true,
      throttled: false,

      maintenance: undefined,
      maintenanceSnackbar: false,

      emailRules: [
        (v) => !this.throttled || this.$i18n.t("messages.loginThrottled"),
        (v) => (v && this.isValid) || this.$i18n.t("messages.wrongPassword"),
        (v) => !!v || this.$i18n.t("messages.emailRequired"),
        // (v) => /.+@.+\..+/.test(v) || this.$i18n.t("messages.wrongEMailFormat"),
      ],
      passwordRules: [
        (v) => (v && this.isValid) || this.$i18n.t("messages.wrongPassword"),
      ],
    };
  },

  components: {
    ThemePickerVue,
  },

  computed: {
    resetURL() {
      return this.axios.defaults.url + "/accounts/password_reset/";
    },
    isDarkTheme() {
      return this.$vuetify.theme.global.current.dark;
    },
    loginCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 5;
        case "xl":
          return 4;
        case "xxl":
          return 3;
        default:
          return 4;
      }
    },
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 7;
        case "xl":
          return 8;
        case "xxl":
          return 9;
        default:
          return 8;
      }
    },
    imageMaxHeigh() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "100px";
        case "sm":
          return "150px";
        default:
          return "200px";
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
      }
    },
    paddingClass() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return "pa-0";
        case "sm":
          return "pa-4";
        case "md":
          return "pa-8";
        case "lg":
          return "pa-12";
        case "xl":
          return "pa-16";
        case "xxl":
          return "pa-16";
        default:
          return "pa-16";
      }
    },
  },

  methods: {
    switchPWDisplay() {
      this.showEyeOpen = !this.showEyeOpen;
    },
    login() {
      if (!this.email || !this.password) {
        return;
      }

      this.loading = true;

      const formData = {
        email: this.email,
        password: this.password,
      };

      this.$store
        .dispatch("loginUser", formData)
        .then(() => {
          this.loading = false;
        })
        .catch((e) => {
          this.isValid = false;
          this.loading = false;

          this.$refs.loginForm.validate();

          if (e.response && e.response.status == 429) {
            this.throttled = true;
            this.$refs.loginForm.validate();
          }
        });
    },
    submitByEnter(e) {
      if (e.key === "Enter" || e.keyCode === 13) {
        if (this.$route.path == "/login") this.login();
      }
    },
    goToRegister() {
      this.$router.push("/register");
    },
    gotoLanding() {
      this.$router.push("/");
    },
    fetchMaintenance() {
      this.axios
        .get(this.axios.defaults.baseURL + "user/maintenance/")
        .then((resp) => {
          this.maintenance = resp.data;

          if (this.maintenance) {
            this.maintenanceSnackbar = true;
          }
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
  },

  mounted() {
    document.getElementById("app").addEventListener("keyup", this.submitByEnter);

    this.fetchMaintenance();

    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 200);
  },

  beforeDestroy() {
    document.getElementById("app").removeEventListener("keyup", this.submitByEnter);
  },
};
</script>
